import { render, staticRenderFns } from "./DeclarationOfAction.vue?vue&type=template&id=da0fec10&scoped=true"
import script from "./DeclarationOfAction.vue?vue&type=script&lang=js"
export * from "./DeclarationOfAction.vue?vue&type=script&lang=js"
import style0 from "./DeclarationOfAction.vue?vue&type=style&index=0&id=da0fec10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0fec10",
  null
  
)

export default component.exports